import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class NotificationsGraphql extends GraphQlService {
  async getAllNotifications() {
    return this.client
      .query({
        query: gql`
          query {
            getAllNotificationsSingle {
              id
              isAllAccount
              sendAt
              message
              sent
              status
              notificationAccounts {
                notificationId
                accountId
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.getAllNotificationsSingle);
  }

  // `pagination` optional — omitted entirely, the backend returns the full
  // set in one call (same convention as UsersGraphqlInstance.getAllUsers).
  // `sent` is the one filter this table has (the Status column's
  // Sent/Upcoming choice); undefined/null means no filter.
  async getNotificationsSinglePage(pagination = {}) {
    const {
      limit, offset, search, sortField, sortOrder, sent,
    } = pagination;
    return this.client
      .query({
        query: gql`
          query GetNotificationsSinglePage(
            $limit: Float
            $offset: Float
            $search: String
            $sortField: String
            $sortOrder: String
            $sent: Boolean
          ) {
            getNotificationsSinglePage(
              limit: $limit
              offset: $offset
              search: $search
              sortField: $sortField
              sortOrder: $sortOrder
              sent: $sent
            ) {
              total
              items {
                id
                isAllAccount
                sendAt
                message
                sent
                status
                notificationAccounts {
                  notificationId
                  accountId
                }
              }
            }
          }
        `,
        variables: {
          limit: limit ?? null,
          offset: offset ?? null,
          search: search ?? null,
          sortField: sortField ?? null,
          sortOrder: sortOrder ?? null,
          sent: sent ?? null,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getNotificationsSinglePage);
  }

  async updateNotificationStatus(id, status) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateNotificationStatus(
            id: "${id}"
            status: "${status}"
          ) {
            id
            status
          }
        }       
        `,
      })
      .then((result) => result?.data?.updateNotificationStatus);
  }

  async createNotifications(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          createNotifications(
            createNotificationsSingleInput: {
              isAllAccount: ${data.isAllAccount}
              sendAt: "${data.sendAt}"
              message: "${data.message}"
              accountIds: ${data.accountIds}
              status: "${data.status}"
            }
          ) {
            id
          }
        }     
        `,
        fetchPolicy: "network-only",
      })
      .then((result) => result?.data?.createNotifications);
  }

  async updateNotifications(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateNotifications(
            updateNotificationsSingleInput: {
              id:"${data.id}"
              isAllAccount: ${data.isAllAccount}
              sendAt: "${data.sendAt}"
              message: "${data.message}"
              accountIds: ${data.accountIds}
              status: "${data.status}"
            }
          ) {
            id
          }
        }
        `,
        fetchPolicy: "network-only",
      })
      .then((result) => result?.data?.updateNotifications);
  }

  async removeNotifications(id) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          removeNotifications(
            id:"${id}"
          )
        }   
        `,
      })
      .then((result) => result?.data?.removeNotifications);
  }

  async getPersonalNotificationsByUser() {
    return this.client
      .query({
        query: gql`
          query {
            getPersonalNotificationsByUser {
              id
              heading
              message
              read
              entityType
              entityId
              reportName
              createdAt
              sender {
                accountId
                profilePictureName
                name
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.getPersonalNotificationsByUser);
  }

  async markPersonalNotificationAsRead(id) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            markPersonalNotificationAsRead(id: "${id}") {
              id
              read
            }
          }
        `,
      })
      .then((result) => result?.data?.markPersonalNotificationAsRead);
  }
}

const NotificationsGraphqlInstance = new NotificationsGraphql();
export default NotificationsGraphqlInstance;
